import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import LogoLine from "../assets/LogoLine.png";
import { Menu, X } from "lucide-react";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const location = useLocation();

  const scrollToContact = () => {
    const contactSection = document.getElementById("footer");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Lock scrolling when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden"; // Disable scrolling
    } else {
      document.body.style.overflow = "auto"; // Enable scrolling
    }

    return () => {
      document.body.style.overflow = "auto"; // Reset on unmount
    };
  }, [isMenuOpen]);

  const isHomePage = location.pathname === "/"; // Check if on homepage

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-in-out transform ${
        isHomePage
          ? isScrolled
            ? "bg-white shadow-sm opacity-100 translate-y-0"
            : "opacity-0 translate-y-[-100%]"
          : "opacity-100 translate-y-0 bg-white shadow-sm"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          <Link to="/" className="flex items-center">
            <img src={LogoLine} alt="Logo" className="h-12 w-auto" />
          </Link>
          <div className="hidden md:flex items-center gap-4 font-aboreto">
            <nav className="flex space-x-4">
              <Link
                to="/"
                className="text-gray-600 hover:text-gray-900 font-aboreto"
              >
                Hem
              </Link>
              <Link
                to="/menu"
                className="text-gray-600 hover:text-gray-900 font-aboreto"
              >
                Meny
              </Link>
              <button
                onClick={scrollToContact}
                className="text-gray-600 hover:text-gray-900"
              >
                Kontakt
              </button>
            </nav>
            <button
              data-hash="405f9dbe95a742d7c2081356d4bb7852"
              className="waiteraid-widget w-full md:w-auto inline-flex items-center justify-center rounded-full borderfont-aboreto py-3 px-8 bg-stone-800 text-white hover:bg-white hover:text-stone-800 border-2 border-stone-800 transition-all duration-300 "
            >
              Boka Bord
            </button>
          </div>
          <button
            className="md:hidden text-gray-600 hover:text-gray-900"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? (
              <X size={24} className="text-black" />
            ) : (
              <Menu size={24} className="text-black" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`${
          isMenuOpen ? "translate-y-0" : "translate-y-[-100%]"
        } md:hidden h-screen fixed inset-0 bg-white z-50 transition-transform duration-300 ease-in-out`}
      >
        <div className="flex flex-col h-full justify-between py-6 px-4">
          {/* Close button */}
          <button
            onClick={() => setIsMenuOpen(false)}
            className="absolute top-6 right-6 text-black"
          >
            <X size={30} />
          </button>
          <nav className="flex flex-col space-y-4 items-center mt-16 font-aboreto">
            <Link
              to="/"
              className="text-gray-600 hover:text-gray-900 text-lg font-aboreto"
              onClick={() => setIsMenuOpen(false)}
            >
              Hem
            </Link>
            <Link
              to="/menu"
              className="text-gray-600 hover:text-gray-900 text-lg font-aboreto"
              onClick={() => setIsMenuOpen(false)}
            >
              Meny
            </Link>
            <button
              onClick={scrollToContact}
              className="text-gray-600 hover:text-gray-900 text-lg"
            >
              Kontakt
            </button>
            <button
              data-hash="405f9dbe95a742d7c2081356d4bb7852"
              className="waiteraid-widget w-full md:w-auto inline-flex items-center justify-center py-3 px-8 rounded-full borderfont-aboreto  bg-stone-800 text-white hover:bg-white hover:text-stone-800 border-2 border-stone-800 transition-all duration-300 "
            >
              Boka Bord
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
};
